(() => {
  if (window.SXTDeliveryV78) return;
  window.SXTDeliveryV78 = true;
  function todayInSofia() {
    const parts = new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Sofia', year:'numeric', month:'2-digit', day:'2-digit'}).formatToParts(new Date());
    const part = type => Number(parts.find(item => item.type === type).value);
    return new Date(Date.UTC(part('year'), part('month') - 1, part('day'), 12));
  }
  function addWeekdays(start, count) {
    const day = new Date(start);
    while (count > 0) {
      day.setUTCDate(day.getUTCDate() + 1);
      if (day.getUTCDay() !== 0 && day.getUTCDay() !== 6) count--;
    }
    return day;
  }
  function update() {
    const start = todayInSofia(), from = addWeekdays(start, 3), to = addWeekdays(start, 5);
    const locale = document.documentElement.lang.toLowerCase().startsWith('en') ? 'en-GB' : 'bg-BG';
    const formatter = new Intl.DateTimeFormat(locale, {timeZone:'UTC',day:'numeric',month:'long',...(from.getUTCFullYear() !== start.getUTCFullYear() || to.getUTCFullYear() !== start.getUTCFullYear() ? {year:'numeric'} : {})});
    const sameMonth = from.getUTCFullYear() === to.getUTCFullYear() && from.getUTCMonth() === to.getUTCMonth();
    const text = sameMonth ? from.getUTCDate() + '–' + formatter.format(to) : formatter.format(from) + ' – ' + formatter.format(to);
    document.querySelectorAll('[data-sxt-delivery-date]').forEach(target => {
      if (target.textContent !== text) target.textContent = text;
    });
  }
  let queued = false;
  const refresh = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; update(); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, {once:true}); else refresh();
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('visibilitychange', refresh);
  new MutationObserver(refresh).observe(document.documentElement, {subtree:true,childList:true});
  setInterval(refresh, 60000);
})();
